__turbopack_context__.v({
  "container": "PhoneInput-module__RhS9xq__container" + " " + __turbopack_context__.i(532823)["container"],
  "content": "PhoneInput-module__RhS9xq__content" + " " + __turbopack_context__.i(532823)["content"],
  "fieldsContainer": "PhoneInput-module__RhS9xq__fieldsContainer",
  "item": "PhoneInput-module__RhS9xq__item" + " " + __turbopack_context__.i(532823)["item"],
  "label": "PhoneInput-module__RhS9xq__label",
  "optionContainer": "PhoneInput-module__RhS9xq__optionContainer",
  "trigger": "PhoneInput-module__RhS9xq__trigger",
  "value": "PhoneInput-module__RhS9xq__value",
});
